import { render, staticRenderFns } from "./AddDepartmentPage.vue?vue&type=template&id=679976a1&"
import script from "./AddDepartmentPage.vue?vue&type=script&lang=js&"
export * from "./AddDepartmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports